var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('li', {
    staticClass: "nav-item menu-items change-sidebar-type-item"
  }, [_c('div', {
    staticClass: "nav-link d-flex align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "menu-icon"
  }, [_c('svg-icon', {
    class: _vm.iconClass,
    attrs: {
      "name": _vm.icon,
      "viewBox": _vm.viewBox,
      "size": "20"
    }
  })], 1), _c('div', {
    staticClass: "menu-title-container"
  }, [_c('span', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('svg-icon', {
    staticClass: "chevron-icon",
    attrs: {
      "size": "20",
      "viewBox": "0 0 20 20",
      "name": "chevron-right",
      "variant": "gray"
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };